module.exports = __webpack_public_path__ + "img/1_002.07984a31.jpg";